/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Protein_Meals_ThreeInputs */

const en_us2_protein_meals_three = /** @type {(inputs: Protein_Meals_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3`)
};

const pt_br2_protein_meals_three = /** @type {(inputs: Protein_Meals_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três`)
};

const es_419_protein_meals_three = /** @type {(inputs: Protein_Meals_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3`)
};

const pt_pt2_protein_meals_three = /** @type {(inputs: Protein_Meals_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Três`)
};

const fr_fr2_protein_meals_three = /** @type {(inputs: Protein_Meals_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`3`)
};

const de_de2_protein_meals_three = /** @type {(inputs: Protein_Meals_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drei`)
};

const it_it2_protein_meals_three = /** @type {(inputs: Protein_Meals_ThreeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tre`)
};

/**
* | output |
* | --- |
* | "3" |
*
* @param {Protein_Meals_ThreeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const protein_meals_three = /** @type {((inputs?: Protein_Meals_ThreeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Protein_Meals_ThreeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_protein_meals_three(inputs)
	if (locale === "es-419") return es_419_protein_meals_three(inputs)
	if (locale === "pt-PT") return pt_pt2_protein_meals_three(inputs)
	if (locale === "fr-FR") return fr_fr2_protein_meals_three(inputs)
	if (locale === "de-DE") return de_de2_protein_meals_three(inputs)
	if (locale === "it-IT") return it_it2_protein_meals_three(inputs)
	return en_us2_protein_meals_three(inputs)
});
export { protein_meals_three as "protein_meals.three" }